<template>
<v-container fluid>
    <v-card class="ma-2" outlined>
        <v-progress-linear indeterminate color="yellow darken-2" v-if="programLoading"></v-progress-linear>
        <v-card-title>
            <div md-5>
                <program-member-data-component :uid="uid"></program-member-data-component>
            </div>
            <!-- <v-btn icon @click="goToProgramView">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            {{ title }} -->
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="ml-5 mt-3" @click="goToUpdateMemberBloodtests" v-if="(allowToManage || isCoach) && !isCancelProgram">
                เพิ่มผลเลือด
            </v-btn>
            <v-btn color="primary" dark class="ml-5 mt-3" @click="goToUpdateMemberBody" v-if="(allowToManage || isCoach) && !isCancelProgram">
                เพิ่มองค์ประกอบร่างกาย
            </v-btn>
            <v-btn color="primary" dark class="ml-5 mt-3" @click="verifyEditState" v-if="allowToManage && !isCancelProgram">
                edit
            </v-btn>
            <v-btn disabled class="ml-5 mt-3" v-if="allowToManage && !enableEndProgram && !isCancelProgram">จบโปรแกรม</v-btn>
            <v-btn color="primary" dark class="ml-5 mt-3" @click="goToProgramEndPage" v-if="allowToManage && enableEndProgram && !isCancelProgram">
                จบโปรแกรม
            </v-btn>
            <v-btn color="primary" dark class="ml-5 mt-3" @click="goToProgramCancelPage" v-if="allowToManage && !isCancelProgram">
                ยกเลิกโปรแกรม
            </v-btn>
        </v-card-title>
        <program-member-form-component :id="id" :uid="uid" :allowToManage="allowToManage" ref="programMemberFormComponent" @toGetOverviewData="toGetOverviewData($event)"></program-member-form-component>
        <v-data-table v-if="!isCancelProgram" :headers="headers" :items="itemList" :search="search" sort-by="onsite" :sort-desc="false"  :hide-default-footer="true" :options="options" :loading="loading">
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon class="mr-2" @click="goToUpdateMember(item)" title="Edit" v-if="allowToManage">
                    mdi-pencil
                </v-icon>
                <v-icon class="mr-2" @click="goToUpdateMember(item)" title="Edit" v-else>
                    mdi-pencil
                </v-icon>
            </template>
        </v-data-table>
    </v-card>
    <v-dialog v-model="dialog" max-width="400px">
        <v-card>
            <v-card-title class="text">ยังไม่สามารถจบโปรแกรมได้<br/>ต้องทำแบบสอบถาม Post Test ก่อน</v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false;">OK</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</v-container>
</template>
<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {
    mapGetters
} from "vuex";
import formatData from "../utils/formatData";
import getUserInfoByUserId from "../data/getUserInfoByUserId";
import getProgramInfoById from "../data/getProgramInfoById";
import getProgramMemberInfo from "../data/getProgramMemberInfo";
import colors from 'vuetify/lib/util/colors';
import moment from "moment";
import ProgramMemberFormComponent from "../components/ProgramMemberFormComponent.vue";
import ProgramMemberDataComponent from "../components/ProgramMemberDataComponent.vue";
export default {
    name: 'ProgramViewMemberEdit',
    metaInfo: {
        title: 'Program View Member Edit'
    },
    components: {
        ProgramMemberFormComponent,
        ProgramMemberDataComponent
    },
    data() {
        return {
            title: '',
            allowToManage: false,
            isCoach: false,
            select: null,
            search: null,
            programLoading: true,
            loading: false,
            isExporting: false,
            onsiteNumber: 0,
            enableEndProgram: false,
            isPostTestCompleted: false,
            isCancelProgram: false,
            // editState: false,
            dialog: false,
            options: {
                itemsPerPage: 20,
            },
            headers: [{
                    text: "ครั้งที่",
                    value: "onsite",
                    align: 'center',
                    sortable: false
                },
                {
                    text: "วันที่",
                    value: "date",
                    align: 'center',
                    sortable: false
                },
                {
                    text: "น้ำหนัก",
                    value: "weight",
                    align: 'center',
                    sortable: false
                },
                {
                    text: "BMI",
                    value: "bmi",
                    align: 'center',
                    sortable: false
                },
                {
                    text: "รอบเอว",
                    value: "waist",
                    align: 'center',
                    sortable: false
                },
                {
                    text: "รอบสะโพก",
                    value: "hip",
                    align: 'center',
                    sortable: false
                },
                {
                    text: "WHR",
                    value: "whr",
                    align: 'center',
                    sortable: false
                },
                {
                    text: "Coach",
                    value: "coach",
                    sortable: false
                },
                {
                    text: "Actions",
                    value: "actions",
                    align: 'center',
                    sortable: false
                }
            ],
            itemList: [],
            valid: false,
            requiredRule: [
                v => !!v
            ],
            adminListResult: [],
            programInfo: {},

            //set default date from last 3 month
            isShowGroupFilter: false,
            startDate: moment().subtract(3, 'month').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),

            userInfo: {
                name: ''
            },
            chartWaistMember: {
                noData: true,
                chartTitle: "Waist",
                title: 'Waist',
                color: 'indigo',
                series: [{
                    name: "Waist",
                    color: colors.indigo.lighten3,
                    data: []
                }],
                forceNiceScale: true,
                maxY: 80,
                score: 50,
            },
            chartBMIMember: {
                noData: true,
                chartTitle: "BMI",
                title: 'BMI',
                color: 'green',
                series: [{
                    name: "BMI",
                    color: colors.green.lighten3,
                    data: []
                }],
                maxY: 35,
                score: 23,
                tickAmount: 2,
                forceNiceScale: true,
                annotations: [{
                    y: 23,
                    borderColor: colors.green.lighten2,
                    label: {
                        borderColor: colors.green.darken4,
                        style: {
                            color: "#FFF",
                            background: colors.green.lighten2
                        },
                        text: '23',
                        position: 'left',
                        offsetX: -10,
                        offsetY: 8
                    }
                }]
            }
        };
    },
    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Coach Program";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.programLoading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });
        
        this.id = this.$route.params.id;
        this.uid = this.$route.params.uid;
    },
    computed: {
        ...mapGetters([
            "isAuthenticated",
            "loggedInUserId",
            "isSuperAdmin",
            "isChallengeAdmin",
            "isAccessCoachAdmin",
            "isAccessOrgAdmin"
        ]),
    },
    methods: {
        initialize() {
            if (this.isAccessCoachAdmin || this.isAccessOrgAdmin) {
                this.toGetOverviewData();
            } else {
                this.$router.push(`/dashboard`);
            }
        },
        toGetOverviewData(){
            (async () => {
                this.programLoading = true;
                this.programInfo = await getProgramInfoById(this.id, this.uid, 1);
                const coachList = this.programInfo.coachList || [];
                if( coachList.length ){
                    this.isCoach = coachList.includes(this.loggedInUserId);
                }
                this.onsiteNumber = 0;
                this.itemList = [];
                for (let i = 1; i <= this.programInfo.memberOnsite; i++) {
                    if( this.programInfo.onsite['onsite'+i] != undefined ){
                        ++this.onsiteNumber;
                    }
                    this.itemList.push({
                        onsite: i,
                        date: this.programInfo.onsite['onsite'+i] != undefined ? formatData('date',this.programInfo.onsite['onsite'+i].date.toDate()) : '-',
                        weight: this.programInfo.onsite['onsite'+i] != undefined ? this.programInfo.onsite['onsite'+i].weight : '-',
                        bmi: this.programInfo.onsite['onsite'+i] != undefined ? this.programInfo.onsite['onsite'+i].bmi : '-',
                        hip: this.programInfo.onsite['onsite'+i] != undefined ? this.programInfo.onsite['onsite'+i].hip : '-',
                        waist: this.programInfo.onsite['onsite'+i] != undefined ? this.programInfo.onsite['onsite'+i].waist : '-',
                        whr: this.programInfo.onsite['onsite'+i] != undefined ? this.programInfo.onsite['onsite'+i].whr : '-',
                        coach: this.programInfo.onsite['onsite'+i] != undefined ? this.programInfo.onsite['onsite'+i].coachInfo.name : '-'
                    });
                }

                this.programMemberInfo = await getProgramMemberInfo(this.id, this.uid);
                this.enableEndProgram = this.programMemberInfo.enableEndProgram;
                this.isPostTestCompleted = this.programMemberInfo.isPostTestCompleted;
                this.isCancelProgram = this.programMemberInfo.isCancelProgram;
                // this.verifyEndProgram();
                this.allowToManage = false;
                if( this.loggedInUserId == this.programInfo.owner ){
                    this.allowToManage = true;
                }
                else{
                    //To remove action column if not allow to edit
                    //But we might need to alllw to see details
                    //Let see how to contin
                    this.headers.splice(2, 1);
                }
                this.userInfo = await getUserInfoByUserId(this.uid);
                this.programLoading = false;
                this.title = this.userInfo.name + ' (' + this.programInfo.name + ')';
            })();
        },
        _formatData(type, value) {
            return formatData(type, value);
        },
        goToProgramView() {
            this.$router.push(`/program/${this.$route.params.mod}/view/${this.id}`);
        },
        goToUpdateMember(item) {
            this.$router.push(`/program/${this.$route.params.mod}/view/${this.id}/${this.uid}/${item.onsite}`);
        },
        goToProgramEndPage() {
            if( this.isPostTestCompleted ){
                this.$router.push(`/program/${this.$route.params.mod}/view/${this.id}/${this.uid}/end`);
            }
            else{
                this.dialog = true;
            }
        },
        goToProgramCancelPage(){
            this.$router.push(`/program/${this.$route.params.mod}/view/${this.id}/${this.uid}/cancel`);
        },
        goToUpdateMemberBloodtests() {
            this.$router.push(`/program/${this.$route.params.mod}/bloodtests/${this.id}/${this.uid}`);
        },
        goToUpdateMemberBody() {
            this.$router.push(`/program/${this.$route.params.mod}/body/${this.id}/${this.uid}`);
        },
        calculateMaxY(maxValue, maxY, point) {
            //compare with maxY
            if (maxValue > maxY) {
                maxY = (maxValue)*1 + point;
            }
            return maxY;
        },
        calculatePercentChanges(a, b) {
            //get max value
            // return (b-a)/a*100;
            let pc = formatData('number', (b-a)/a*100);
            if ( pc > 0 ){
                pc = `+${pc}`;
            }
            return pc;
        },
        verifyEditState(){
            this.$refs.programMemberFormComponent.verifyEditState();
        }
    },
};
</script>
